const choiceForms: NodeListOf<HTMLElement> = document.querySelectorAll(".js-choice-form");

if(choiceForms) {

  const choiceAddButton: HTMLElement = document.querySelector(".js-choice-form-button")!;

  if (choiceAddButton) {

    choiceAddButton.addEventListener("click", (event: any) => {
      const choiceFormsHidden: NodeListOf<HTMLElement> | any = Array.from(choiceForms).filter((form: HTMLElement) => {
        return form.style.display == "none";
      }) 
      console.log(choiceFormsHidden);

      if (choiceFormsHidden) {
        choiceFormsHidden[0].style.display = "block";
      } 

      console.log(choiceFormsHidden.length);

      if(choiceFormsHidden.length == 1) {
        console.log("asdf");
        choiceAddButton.style.opacity = "0.3";
        choiceAddButton.style.pointerEvents = "none";
        choiceAddButton.style.filter = "grayscale(1)";
      }

      event.preventDefault();
    })
  }

}
